import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core'

import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import {
	BranchInformationModel,
	City,
	UpdateBasicInfoModel,
	isBranchInfoValid,
} from '../../models/branch-information.model'
import { OrganizationsService } from '../../services/organizations.service'
import { Subscription } from 'rxjs'
import { ActivatedRoute } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { Pattern } from 'src/app/shared/constants/patterns.constant'

@Component({
	selector: 'app-organization-branch-basic-info',
	templateUrl: './organization-branch-basic-info.component.html',
	styleUrls: ['./organization-branch-basic-info.component.scss'],
})
export class OrganizationBranchBasicInfoComponent
	implements OnInit, OnChanges, OnDestroy
{
	@Input() branchInformationData = new BranchInformationModel()
	@Input() type!: number
	@Output() dataChanged: EventEmitter<any> = new EventEmitter()
	basicInfoForm!: FormGroup
	editInfoMode: boolean = false
	subscription = new Subscription()
	cities: City[] = []
	branchId = ''
	isDataValid = true
	nameError = ''
	isContactDataValid: isBranchInfoValid = new isBranchInfoValid()
	isMobileValid = false
	showContactMessage = false
	contactInfoForm!: FormGroup
	selectedCountry: number | undefined = 0
	newBranchName: string = ''
	constructor(
		public translate: TranslateService,
		private organizationsService: OrganizationsService,
		private routeActivate: ActivatedRoute,
		private dialog: MatDialog,
		private toaster: ToastrService
	) {}

	ngOnInit(): void {
		this.routeActivate.params.subscribe(({ id }) => {
			this.branchId = id
		})
	}

	ngOnChanges(): void {
		this.initBasicInformationValues()
		this.initContactInformationValues()
		this.nameValueChange()
		this.branchInformationData?.country
			? this.GetCityByCountry(this.branchInformationData?.country?.id)
			: null
		this.selectedCountry = this.branchInformationData?.city?.id
	}

	initBasicInformationValues() {
		this.basicInfoForm = new FormGroup({
			name: new FormControl(
				this.newBranchName
					? this.newBranchName
					: this.branchInformationData?.name,
				[Validators.required]
			),
			isMain: new FormControl(
				{ value: this.branchInformationData?.isMain, disabled: true },
				[]
			),
			cityId: new FormControl(
				this.getController('cityId')?.value
					? this.getController('cityId')?.value
					: this.branchInformationData?.city?.id,
				Validators.required
			),
		})
	}
	initContactInformationValues() {
		this.contactInfoForm = new FormGroup({
			mobileNumber: new FormControl(
				this.branchInformationData?.mobileNumbers,
				Validators.required
			),
			landline: new FormControl(this.branchInformationData?.landline, [
				Validators.pattern(
					
					this.branchInformationData?.country?.id == 103
						? Pattern?.SaudiLandLinePattern
						: Pattern?.egyptLandlinePattern
				),
			]),
		})
		this.subscription.add(
			this.contactInfoForm.valueChanges.subscribe((res) => {
				this.showContactMessage = false
				this.isContactDataValid = new isBranchInfoValid()
			})
		)
	}
	nameValueChange() {
		this.subscription.add(
			this.basicInfoForm.get('name')?.valueChanges.subscribe(() => {
				this.isDataValid = true
			})
		)
	}
	checkValidation(cityId?: number) {
		const body: UpdateBasicInfoModel = {
			id: this.branchInformationData?.id,
			isMain: this.getController('isMain')?.value,
			name: this.getController('name').value,
			cityId: cityId ? cityId : this.getController('cityId').value,
		}

		this.subscription.add(
			this.organizationsService.BranchValidateUniqueName(body).subscribe({
				next: (res: any) => {
					this.isDataValid = res?.result

					this.isDataValid ? this.updateData(body, false) : null
				},
				error: (err: any) => {
					this.isDataValid = false
					this.basicInfoForm.controls['name'].setErrors({ duplicate: true })
					this.nameError = err?.error?.error?.message
				},
			})
		)
	}
	countryChange(event: any) {
		this.selectedCountry = event
		this.getController('cityId').setValue(event)
	}
	updateData(body: any, contactInfo: boolean) {
		if (!contactInfo) {
			this.subscription.add(
				this.organizationsService.updateBranchBasicInformation(body).subscribe({
					next: () => {
						this.branchInformationData = {
							...this.branchInformationData,
							...body,
						}
						let city = this.cities.find((obj) => obj?.id == body?.cityId)
						city ? (this.branchInformationData.city = city) : null
						this.editInfoMode = false
						this.dataChanged.emit()
						this.toaster.success(this.translate.instant('TOASTER.MSG_SUCCESS'))
					},
				})
			)
		} else {
			this.subscription.add(
				this.organizationsService
					.updateBranchContactInformation(body)
					.subscribe({
						next: () => {
							this.branchInformationData = {
								...this.branchInformationData,
								...body,
							}
							this.editInfoMode = false
							this.dataChanged.emit()
							this.toaster.success(
								this.translate.instant('TOASTER.MSG_SUCCESS')
							)
						},
					})
			)
		}
	}

	GetCityByCountry(id: any) {
		this.subscription.add(
			this.organizationsService.GetCityByCountry(id).subscribe({
				next: (res: any) => {
					this.cities = res.result
				},
			})
		)
	}

	changeBranchName() {
		this.newBranchName = this.getController('name').value
	}
	changeEditMode() {
		this.editInfoMode = !this.editInfoMode

		this.editInfoMode == true ? this.nameValueChange() : ''
		if (this.branchInformationData?.hasAppointments) {
			this.getController('cityId')?.disable()
		}
	}

	getController(controlName: string) {
		return this.basicInfoForm?.controls[controlName] as FormControl
	}
	getContactController(controlName: string) {
		return this.contactInfoForm?.controls[controlName] as FormControl
	}

	compareWith(a: any, b: any) {
		return a == b
	}
	changeNameConfirmation() {
		if (
			this.branchInformationData?.hasAppointments &&
			this.branchInformationData?.name !==
				this.basicInfoForm?.get('name')?.value?.trim()
		) {
			//
			this.dialog
				.open(ConfirmationMessageComponent, {
					width: '750px',
					data: {
						image: 'assets/images/correct.svg',
						flex: true,

						message: this.translate.instant(
							'CONFIRMATION_MESSAGE.CHANGE_NAME',
							{
								name: this.branchInformationData?.name,
							}
						),

						cancelBtn: 'ACTIONS.NO',
						confirmBtn: 'ACTIONS.YES',
					},
				})
				.afterClosed()
				.subscribe({
					next: (res) => {
						if (
							!this.getContactController('landline')?.value?.length &&
							!this.getContactController('mobileNumber')?.value?.length
						)
							this.showContactMessage = true
						else {
							this.submitForm()
						}
						if (res) {
							// this.changeCityConfirmation()
							this.checkValidation()
						}
					},
				})
		} else {
			if (
				!this.getContactController('landline')?.value?.length &&
				!this.getContactController('mobileNumber')?.value?.length
			)
				this.showContactMessage = true
			else {
				this.submitForm()
			}

			this.changeCityConfirmation()
		}
	}
	changeCityConfirmation() {
		if (
			this.branchInformationData?.city?.id !==
			this.getController('cityId').value
		) {
			this.dialog
				.open(ConfirmationMessageComponent, {
					width: '585px',
					height: '350px',

					data: {
						image: `assets/images/correct.svg
					`,
						notflex: true,

						message: 'CONFIRMATION_MESSAGE.CHANGE_CITY_CONFIRMATION',
						cancelBtn: 'ACTIONS.CANCEL',
						confirmBtn: 'ACTIONS.OK',
					},
				})
				.afterClosed()
				.subscribe({
					next: (res) => {
						if (res) {
							this.checkValidation()
						}
					},
				})
		} else {
			this.checkValidation()
		}
	}
	submitForm() {
		if (
			!this.getContactController('landline')?.value?.length &&
			!this.getContactController('mobileNumber')?.value?.length
		)
			this.showContactMessage = true
		else {
			const body = {
				id: this.branchInformationData?.id,
				landline: this.getContactController('landline')?.value,
				mobileNumbers: this.getContactController('mobileNumber').value,
				tenantId: this.branchInformationData?.tenantId,
			}

			this.subscription.add(
				this.organizationsService
					.BranchValidateUniqueContact(body)
					.subscribe((res: any) => {
						this.showContactMessage = false
						this.isDataValid = res?.result
						this.isContactDataValid?.isInfoValid
							? this.updateData(body, true)
							: null
					})
			)
		}
	}
	changeStoreStatus(event: any) {
		event.checked

		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '585px',
				height: '350px',

				data: {
					image: !event?.checked
						? 'assets/images/block.svg'
						: 'assets/images/correct.svg',
					notflex: true,

					message: !event?.checked
						? 'CONFIRMATION_MESSAGE.DEACTIVATION_CONFIRMATION'
						: 'CONFIRMATION_MESSAGE.ACTIVATION_CONFIRMATION',
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: !event?.checked
						? 'ACTIONS.DEACTIVATE'
						: 'ACTIONS.ACTIVATE',
					confirmBtnStyle: !event?.checked
						? 'text-secondry-color-Gray'
						: 'text-off-white bg-gradient',
					cancelBtnStyle: !event?.checked
						? 'bg-gradient text-off-white'
						: 'text-medium-gray bg-transparent rounded-6px border-[1px] border-secondry-color-Gray',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
					}
				},
			})
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
